import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { tokens, loading } = useContext(AuthContext);

  // Wait for authentication state restoration
  if (loading) {
    return <p>Loading...</p>; // Show a loading message or spinner
  }

  // Redirect to /login if the user is not authenticated
  if (!tokens.accessToken) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default ProtectedRoute;
